import React from "react";
import "./Signature/sigCanvas.css";
import TextField from "@material-ui/core/TextField/TextField";
import {bindActionCreators} from "redux";
import {addVariableData, requestGetPlanningsData} from "../../actions";
import {connect} from "react-redux";
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';
import ImageUploader from "../Category/SocialFeed/ImageUploader";
import {uploadMediaStatic} from "../../api/api.form";

class FormulaireRegister extends React.Component{
    render() {
        const dyn_string  = this.props.t;

        let label = {};
        let errorRegister = {};

        Object.entries(this.props.formData).forEach(([res]) => {
            if(this.props.formState[res+"error"]){
                label[res] = this.props.formState[res+"error"]
                errorRegister[res] = true;
            }else{
                label[res] = res;
                errorRegister[res] = false;
            }
        })

        let display_login_field;

        const handleChangeProfilMedia = async (file) => {

            console.log('Fichier image sélectionné:', file);
            // Tu pourrais ici l’envoyer vers un backend
            // go upload


            //si c'est un fichier on l'upload, si c'est une url on la met dans selectedImageUrl
            if (file && file.type) {
                const responseUploadMediaStatic = await uploadMediaStatic(file);
                console.log('responseUploadMediaStatic:', responseUploadMediaStatic);
                if (responseUploadMediaStatic.success) {
                    //handle change
                    this.props.handleChange({
                        target: {
                            name: "profilMedia",
                            value: responseUploadMediaStatic.result.file_url
                        }
                    });
                } else {
                    console.error('Erreur lors de l\'upload de l\'image:', responseUploadMediaStatic.error);
                }
            }
            else {
                // Si c'est une URL, on la met directement dans le state
                this.props.handleChange({
                    target: {
                        name: "profilMedia",
                        value: file
                    }
                });
            }
        };

        const handleImageRemoved = () => {
            this.props.handleChange({
                target: {
                    name: "profilMedia",
                    value: ""
                }
            });
        };

        let profilPicture;

        if(this.props.application.getApp.has_mobinaute_media === "1") {
            profilPicture = <ImageUploader id="profilMedia" name="profilMedia" onImageSelected={handleChangeProfilMedia}
                                           multiple={false}
                                           onImageRemoved={handleImageRemoved}
                                           label={dyn_string('profile_label_profil_picture')}
                                           positionPreview={"below"}/>
        }


        if(this.props.application.getApp.is_mail_login === "0"){
            display_login_field = <TextField
                key={"RegisterForm_login"}
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="login"
                autoComplete="login"
                type="text"
                placeholder={dyn_string('profile_placeholder_login')}
                value={this.props.formState.value}
                onChange={this.props.handleChange}
                label={dyn_string('profile_label_login')}
                error={errorRegister["login"]}
            />
        } else {
            display_login_field = ""
        }

        return (
            <>
                {profilPicture && (
                    <div style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        marginBottom: "20px"
                    }}>
                        {profilPicture}
                    </div>
                )}

                <TextField
                    key={"RegisterForm_firstname"}
                    aria-required={true}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="firstname"
                    autoComplete="firstname"
                    name="firstname"
                    type="text"
                    placeholder={dyn_string('profile_label_fistname')}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={dyn_string('profile_label_fistname')}
                    error={errorRegister["firstname"]}
                />
                <TextField
                    key={"RegisterForm_lastname"}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="lastname"
                    autoComplete="lastname"
                    name="lastname"
                    type="text"
                    placeholder={dyn_string('profile_label_lastname')}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={dyn_string('profile_label_lastname')}
                    error={errorRegister["lastname"]}
                />

                {display_login_field}

                <TextField
                    key={"RegisterForm_email"}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="Email"
                    autoComplete="Email"
                    name="Email"
                    type="mail"
                    placeholder={dyn_string('profile_placeholder_mail')}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={label["Email"]?label["Email"]:dyn_string('profile_label_mail')}
                    error={errorRegister["Email"]}
                />
                <TextField
                    key={"RegisterForm_password"}
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    id="password"
                    autoComplete="password"
                    name="password"
                    type="password"
                    placeholder={dyn_string('profile_placeholder_password')}
                    value={this.props.formState.value}
                    onChange={this.props.handleChange}
                    label={dyn_string('profile_label_password')}
                    error={errorRegister["pass"]}
                />
            </>
        )
    }
}

const mapStateToProps = (state) => ({
    variableStorage: state.variableStorage,
    styles: state.style,
    application: state.application,
    profil: state.profil,
    routes: state.routes
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            addVariableData,
            requestGetPlanningsData,
        },
        dispatch
    );

export default compose(withTranslation(), connect(mapStateToProps, mapDispatchToProps))(FormulaireRegister);
